<article class="article-detail">
	<header
		class="article-detail__header"
		[ngStyle]="{ 'background-image': checkPictureUrl(announcement?.pictureUrl) }"
		*ngIf="announcement?.pictureUrl">
		<a
			*ngIf="announcement?.pictureLinkUrl"
			mat-raised-button
			class="article-detail__cta"
			[href]="announcement?.pictureLinkUrl"
			target="_blank">
			<ats-icon name="exit"> </ats-icon>
			<span cmLocalize="Announcements/System.AnnouncementDetail.Button.MoreInfo">
				More information
			</span>
		</a>
	</header>
	<div class="article-detail__container">
		<h3 *ngIf="announcement?.headline" class="article-detail__title">
			{{ announcement.headline }}
		</h3>
		<div *ngIf="announcement?.summary" class="article-detail__summary">
			{{ announcement.summary }}
		</div>
		<div *ngIf="announcement?.body" [innerHTML]="sanitizeHtml(announcement.body)"></div>
	</div>
</article>
